import React from 'react'
import { useLinks, LinksProps } from './useLinks'
import { Link } from 'react-router-dom'
import styles from './Links.module.scss'

const Links: React.FC<LinksProps> = (props: LinksProps) => {
  const { t } = useLinks(props)

  return (
    <div className={`col-lg-6 col-xl-3 ${styles['footer-links']}`}>
      <h4 className={styles.title}>{t('quickLinks')}</h4>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link to='/' className={styles.link}>
            {t('navHome')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/About' className={styles.link}>
            {t('navAboutUs')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/Departments' className={styles.link}>
            {t('navDepartments')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/News' className={styles.link}>
            {t('navNews')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/OurTeam' className={styles.link}>
            {t('navOurTeam')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/Contact' className={styles.link}>
            {t('navContactUs')}
          </Link>
        </li>
        <li className={styles.item}>
          <Link to='/Donate' className={styles.link}>
            {t('navDonate')}
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default Links
